
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Header from "./Header";
import Footer from "./Footer";

const PodNotFoundState = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#f9f8f5]">
      <Header />
      <main className="pt-20">
        <div className="max-w-[800px] mx-auto px-4 desktop:px-24 laptop:px-20 tablet:px-12 mobile:px-6 py-12">
          <div className="text-center py-12">
            <div className="text-gray-500 text-lg">Pod not found</div>
            <button
              onClick={() => navigate('/')}
              className="mt-4 text-[#374151] hover:underline flex items-center gap-2 mx-auto"
            >
              <ArrowLeft size={16} />
              Back to Home
            </button>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default PodNotFoundState;
